import React from "react";

export default function ({ children }) {
  return <div>{children}</div>;
}
